import { format } from "date-fns";

import CheckFolios from "../components/CheckFolios";
import { getViewFields } from "componentsv2/tools/functions";
import { layout as layoutFolio } from "../models/folio";
import proxy from "api/proxy";

function CheckOut({ globalSearch }) {
  const layout = layoutFolio();

  async function getFolios(location, wordsSearch) {
    const fieldsNames = getViewFields(layout, "cards");
    fieldsNames.push("booking.payments");
    fieldsNames.push("check_out_time");
    fieldsNames.push("booking.party.name");
    const orderBy = [["room.code", "ASC"]];
    const today = format(new Date(), "yyyy-MM-dd");
    const dom = [["departure_date", "=", today]];

    if (wordsSearch.value) {
      dom.push([
        "OR",
        ["room.code", "ilike", `%${wordsSearch.value}%`],
        ["main_guest.name", "ilike", `%${wordsSearch.value}%`],
        ["main_guest.id_number", "ilike", `%${wordsSearch.value}%`],
        ["vehicle_plate", "ilike", `%${wordsSearch.value}%`],
      ]);
    }

    if (location.value) {
      dom.push(["room.location", "=", location.value]);
    }

    const { data } = await proxy.search(
      "hotel.folio",
      dom,
      fieldsNames,
      null,
      orderBy,
    );
    const res = {
      pendingCheck: [],
      doneCheck: [],
    };
    for (const folio of data) {
      if (folio.registration_state === "check_out") {
        res.doneCheck.push(folio);
      } else {
        res.pendingCheck.push(folio);
      }
    }

    return res;
  }

  return <CheckFolios getFolios={getFolios} queryKey="foliosCheckOut" />;
}

export default CheckOut;
